import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface ProfileFormData {
  organizationName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  peoReferralCode?: string;
}

interface ProfileInformationFormProps {
  formData: ProfileFormData;
  onFormDataChange: (data: ProfileFormData) => void;
}

export const ProfileInformationForm = ({ formData, onFormDataChange }: ProfileInformationFormProps) => {
  const handleFieldChange = (field: keyof ProfileFormData, value: string) => {
    onFormDataChange({
      ...formData,
      [field]: value
    });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-foreground">Contact Information</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="organizationName" className="text-sm font-medium text-muted-foreground">
            Organization Name *
          </Label>
          <Input
            id="organizationName"
            type="text"
            value={formData.organizationName}
            onChange={(e) => handleFieldChange('organizationName', e.target.value)}
            placeholder="Enter your organization name"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone" className="text-sm font-medium text-muted-foreground">
            Phone Number *
          </Label>
          <Input
            id="phone"
            type="tel"
            value={formData.phone}
            onChange={(e) => handleFieldChange('phone', e.target.value)}
            placeholder="(555) 123-4567"
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName" className="text-sm font-medium text-muted-foreground">
            First Name *
          </Label>
          <Input
            id="firstName"
            type="text"
            value={formData.firstName}
            onChange={(e) => handleFieldChange('firstName', e.target.value)}
            placeholder="Enter your first name"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="lastName" className="text-sm font-medium text-muted-foreground">
            Last Name *
          </Label>
          <Input
            id="lastName"
            type="text"
            value={formData.lastName}
            onChange={(e) => handleFieldChange('lastName', e.target.value)}
            placeholder="Enter your last name"
            required
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium text-muted-foreground">
          Email Address *
        </Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => handleFieldChange('email', e.target.value)}
          placeholder="your.email@example.com"
          required
        />
        <p className="text-xs text-muted-foreground">
          Use your company email for PEO verification (e.g., name@yourcompany.com)
        </p>
      </div>
    </div>
  );
};